import {Dropdown, Field, Item, Label, Menu, Select} from "@zendeskgarden/react-dropdowns";
import {ReactElement, useState} from "react";

import * as css from "./styles/acquisitionPropertyFormStyles.module.scss";
import {Message} from "@zendeskgarden/react-forms";

export interface IAcquisitionPropertyFormDropdown {
    label: string,
    required?: boolean,
    selection: any,
    options: any[],
    error?: string,
    onSelect: (item: any) => void,
    onBlur?: () => void,
    isMultiselect?: boolean,
    downshiftProps?: any,
}

export default function AcquisitionPropertyFormDropdown(props: IAcquisitionPropertyFormDropdown): ReactElement {
    const {
        label,
        required = false,
        selection,
        options,
        onSelect,
        error,
        onBlur,
        downshiftProps,
    } = props;

    function renderOptions() {
        return options.map((option, index) => {
            if (typeof option === 'object' && option !== null) {
                return (
                    <Item key={index} value={option}>
                        {option.name}
                    </Item>
                );
            } else {
                return (
                    <Item key={index} value={option}>
                        {option}
                    </Item>
                );
            }
        });
    }

    function getSelectedItemText() {
        if (typeof selection === 'object' && selection !== null) {
            return selection.name || selection;
        }
        return selection;
    }

    return (
        <Dropdown
            onSelect={onSelect}
            downshiftProps={downshiftProps}
        >
            <Field>
                <Label className={css.acquisitionPropertyFormLabel}>
                    <span>{label}</span>
                    {required && <span className={css.required}>REQUIRED</span>}
                </Label>

                <Select validation={error ? "error" : undefined} onBlur={onBlur}>
                    {getSelectedItemText()}
                </Select>
                {error && <Message validation="error">{error}</Message>}
            </Field>
            <Menu>
                {renderOptions()}
            </Menu>
        </Dropdown>
    );
}